import styled from 'styled-components';

export const DatosPersonales = styled.div`

#cargo-selector label {
    margin-bottom: 5px;
}

i.coopeuch-icon.icon-old._1sTuD._1ZA_Y._2HYPo {
    display: none;
}

._20O0A i {
    display: none !important;
}

.Autocomplete-selector input{
    font-size: 0.9rem;
}

._3kii5 input:focus {
    border-color: #646569;
}

._2kFow {
    margin-bottom: 1px;
}

form.formulario-datos-personales button ._20O0A{
    pointer-events: none;
    outline: none;
}
._20O0A {
    pointer-events: none;
    outline: none;
}
form.formulario-datos-personales ._1IDgx{
    display:none;

}

form.formulario-datos-personales .label-fullWidth{
    grid-column-end: span 2;
    color: #4c4c4c;
}

._2MggJ input {
    padding-left: calc(1rem + 47px);
}

.label-radio {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 80%;
    padding-bottom: 16px;
}
.label-radio p {
    font-size: 0.9rem;
    font-weight: 500;
}
.Autocomplete-selector label {
    font-weight: bold;
}
.datos-radio {
    font-size: 1rem;
    font-weight: bold !important;
    color: #383838;
    line-height: 20px;
    margin-bottom: 16px;
}
._1oqQj:hover:after {
    background-color: transparent;
}
.contenido.off div {
    opacity: 0.6;
}
.contenido .of  .label-radio{
    opacity: 0.6;
}
.contenido.off {
    background-color: #c1c1c10f;
    pointer-events: none;
}
.contenido.off p.datos-radio {
    opacity: 0.5;
}

.none-label{
    display:none;
}

.label label {
    font-size: 0.8rem;
}
.tooltip {
    display: flex;
}

.tooltip p {
    font-size: 0.8rem;
    color: #383838;
    font-weight: bold;
    font-family: inherit;
}

.tooltip img {
    margin-top: -2px;
    margin-left: 9px;
}
._2kFow ._3hy_8 {
    margin-right: -103px;
    width: 227px;
    text-align: center;
}



    @media (min-width: 768px){
        .formulario-datos-personales{
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 91px;
            gap: 28px;
        }

    }

  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    form imput{
     font-size:1.2rem
    }
 card{
     margin-right: auto;
     margin-left: auto;
 }
 form.formulario-datos-personales label {
    font-size: 0.8rem;
}

form.formulario-datos-personales .label-fullWidth{
    grid-column-end: span 1
}

form.formulario-datos-personales .label-fullWidth .no-maxWidth .customCheck label p{
    width: 85%;
    font-size: 0.8rem;
}
 .formulario-datos-personales {
     display: grid;
     grid-template-columns: 1fr;
     grid-template-rows: 54px;
     gap: 26px;
 }
 .label-text h6 {
     font-size: 0.8rem;
 }
//  .label span {
//      font-size: 0.7rem;
//  }
//  form ._2lUSM{
//      margin-bottom: 0px;
//  }
  ._3g_Jc p {
      font-size: 0.9rem;
 }
 .formulario-datos-laborales{
     grid-template-columns: 1fr;
     grid-template-rows: 65px;
 }
 p.datos-radio {
     font-size: 0.8rem;
     
 }
 .label-radio {
     grid-template-columns: 1fr;
     width: 100%;
 }
 .label-radio p {
     font-size: 0.7rem;
     right: 10px;
     position: relative;
 }
 ._1oqQj {
     right: 10px;
 }
 
.formulario-datos-personales .Autocomplete-selector{
     padding-top: 15px;
 }
 ._3kii5 input {
     font-size: 0.7rem;
 }
 .Autocomplete-selector input {
     height: 40px;
 }
 .Autocomplete-selector label {
     font-size: 0.7rem;
 }

 ._3SDeG ._1ZRzS ._3k3jO{
     line-height: inherit;
     height: 38px;
 }

 form.formulario-datos-laborales.editar-row{
     grid-template-rows: 85px
 }
 ._1F3qg {
     font-size: 0.7rem;
 }
 .solo-responsive{
     top: 10px;
 position: relative;
 }
 
 .Autocomplete-input-wrapper input {
     font-size: 0.7rem;
 }
 div#cargo-selector input {
     font-size: 0.7rem;
 }
}
`;

export default DatosPersonales;

